import { Box, type ColorUnion, Tag } from '@factorialco/deprecated-design-system'
import {
  PerformanceEngagementAggregationSignalTagFragment,
  PerformanceEngagementSignalTagFragment,
  PerformanceEngagementSignalTagWithQuotesFragment,
  PerformanceEngagementSignalsSignalTypeEnum,
} from 'generated/resources/graphql'

import WithToolTip from 'modules/performance_analytics/components/WithTooltip'

interface Prop {
  engagementSignal:
    | PerformanceEngagementSignalTagFragment
    | PerformanceEngagementSignalTagWithQuotesFragment
    | PerformanceEngagementAggregationSignalTagFragment
}

const colorForType = (type: PerformanceEngagementSignalsSignalTypeEnum): ColorUnion => {
  switch (type) {
    case 'positive':
      return 'viridian'
    case 'negative':
      return 'radical'
    default:
      return 'champagne'
  }
}

export const EngagementSignalTag = ({ engagementSignal }: Prop) => {
  const hasQuotes = 'quotes' in engagementSignal
  const hasCount = 'count' in engagementSignal

  return (
    <Box width="fit-content">
      <WithToolTip
        label={hasQuotes ? engagementSignal.quotes?.join('\n') : undefined}
        whiteSpace="breakSpaces"
        trackingGroup="engagement-signal"
      >
        <Tag type={colorForType(engagementSignal.type)} size="small" ellipsis>
          {engagementSignal.name}
          {hasCount && ` (${engagementSignal.count})`}
        </Tag>
      </WithToolTip>
    </Box>
  )
}
